import React from "react";
import { Button, NumberInput, ReferenceInput, required, SelectInput, TextInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import AddIcon from "@mui/icons-material/Add";
import { administrationRequests } from "api/administrationApi";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const AddIndividualExamDialog = ({ disciplineId, educationId, fetchDisciplineData }) => {
  const notify = useNotify();

  const handleConfirm = async values => {
    const { disciplineId, examName, semester, type, grade } = values;
    const payload = {
      disciplineId: Number(disciplineId),
      examName,
      semester,
      type,
      grade,
      studentEducationId: educationId,
    };
    await dataProvider.customRequest(studentRequests.createIndividualExam(), payload, "POST");
    notify("Успешно добавихте индивидуален изпит", { type: "success" });
    fetchDisciplineData();
  };

  return (
    <FormModal
      titleContent="Добави оценка"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Добави оценка"
          startIcon={<AddIcon />}
          variant="contained"
          size="small"
        />
      }
    >
      <Grid
        container
        columnSpacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <ReferenceInput
            source="disciplineId"
            reference={administrationRequests.getDisciplinesSelect()}
          >
            <SelectInput
              optionText="name"
              label="Дисциплина"
              defaultValue={disciplineId}
              disabled
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="examName"
            label="Име на изпит"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="semester"
            label="Семестър"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="type"
            reference={studentRequests.getIndividualExamsTypesSelect()}
          >
            <SelectInput
              optionText="name"
              label="Тип изпит"
              emptyText={false}
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="grade"
            label="Оценка"
            min={2}
            max={6}
            step={0.01}
            validate={required()}
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default AddIndividualExamDialog;
